"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateMinimumDateInfo = exports.validateMinimumDateSync = exports.validateMinimumDate = exports.shouldValidate = void 0;
const error_1 = require("../../../error");
const date_1 = require("../../../utils/date");
const isValidatableDateComponent = (component) => {
    var _a;
    return component && component.type === 'datetime' && ((_a = component.widget) === null || _a === void 0 ? void 0 : _a.hasOwnProperty('minDate'));
};
const shouldValidate = (context) => {
    var _a;
    const { component, value } = context;
    if (!isValidatableDateComponent(component) || !value) {
        return false;
    }
    if (!(0, date_1.getDateSetting)((_a = component.widget) === null || _a === void 0 ? void 0 : _a.minDate)) {
        return false;
    }
    return true;
};
exports.shouldValidate = shouldValidate;
const validateMinimumDate = (context) => __awaiter(void 0, void 0, void 0, function* () {
    return (0, exports.validateMinimumDateSync)(context);
});
exports.validateMinimumDate = validateMinimumDate;
const validateMinimumDateSync = (context) => {
    var _a, _b, _c, _d;
    const { component, value } = context;
    if (!(0, exports.shouldValidate)(context)) {
        return null;
    }
    if (typeof value !== 'string') {
        throw new error_1.ProcessorError(`Cannot validate day value ${value} because it is not a string`, context, 'validate:validateMinimumDate');
    }
    const date = (0, date_1.dayjs)(value);
    let minDate = (0, date_1.getDateSetting)((_a = component.widget) === null || _a === void 0 ? void 0 : _a.minDate);
    if (minDate === null) {
        return null;
    }
    minDate = ((_b = component.widget) === null || _b === void 0 ? void 0 : _b.enableTime) ? (0, date_1.dayjs)(minDate) : (0, date_1.dayjs)(minDate).startOf('day');
    const error = new error_1.FieldError('minDate', Object.assign(Object.assign({}, context), { minDate: (0, date_1.getFormattedDateSetting)(minDate, component, (_d = (_c = context.submission) === null || _c === void 0 ? void 0 : _c.metadata) === null || _d === void 0 ? void 0 : _d.timezone), setting: String(minDate) }));
    return date.isAfter(minDate) || date.isSame(minDate) ? null : error;
};
exports.validateMinimumDateSync = validateMinimumDateSync;
exports.validateMinimumDateInfo = {
    name: 'validateMinimumDate',
    process: exports.validateMinimumDate,
    processSync: exports.validateMinimumDateSync,
    shouldProcess: exports.shouldValidate,
};
